import React, { memo, useCallback } from 'react';
import './SpnIdStyle.scss';
import useSpnId from './useSpnId';

function SpnId({ style, classname = '' }) {
  const spnId = useSpnId();

  const copySpnId = useCallback(() => {
    if (spnId) {
      navigator.clipboard.writeText(spnId);
    }
  }, [spnId]);

  return (
    <div className={`spn-container ${classname}`} style={style}>
      <div className="header">SPN ID</div>
      <div className="spn-name-box">
        <span className="spn-id">{spnId}</span>
        <a onClick={copySpnId} className="copy-btn">
          Copy ID
        </a>
      </div>
    </div>
  );
}

export default memo(SpnId);
